import { InsuranceOrderCardProps } from 'entities/common/my-ticket/model/types'
import { mapInsuredPersons } from 'entities/insurance'

import { InsuranceOrderDto } from 'shared/api/insurance'
import { CurrencySom } from 'shared/constants'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import { priceShow } from 'shared/lib/priceShow'

export const mapInsuranceOrder = (
  item: InsuranceOrderDto,
): InsuranceOrderCardProps => {
  const price = priceShow(item.conv_premiya_insurance)

  return {
    type: 'insurance',
    id: item.id,
    orderStatus: item.status,
    paymentTtlSeconds: Math.max(0, item.payment_ttl_seconds || 0),
    title: item.country_names?.join(', ') || '—',
    zone: item.zone_name || '—',
    policyNumber: item.polis,
    participantsCount: item.participants_count,
    participants: mapInsuredPersons(item.participants),
    coverage: (item.program_name || '').replace(/\s+/g, ' ') || '—',
    description: item.description || '',
    periodStart: dateFormat(
      item.start_date,
      DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR,
    ),
    periodEnd: dateFormat(item.end_date, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR),
    price: price ? `${price} ${CurrencySom}` : '—',
    pdfUrl: item.pdf_url,
  }
}
